<template>
  <div @click="openDay" class="calendar-date" :class="{'is-selected': selected, 'tooltip': filteredTotalEvents > 0 && !selected, 'is-disabled' : past}"
       :data-tooltip="tooltipContent">
    <button class="date-item" :class="{'is-active' : isToday}">{{date.format('DD')}}</button>
    <div v-if="filteredTotalEvents > 0" class="calendar-events">
      <a v-if="filteredRdvs.length > 0 && showRdvs" class="calendar-event has-bg-rdv" @click="goToDayView('RDVS')">
        {{filteredRdvs.length}} Rendez-vous.
      </a>
      <!-- <a v-if="reminders.length > 0 && showReminders" class="calendar-event has-bg-danger">
        {{reminders.length}} Rappels.
      </a> -->
      <a v-if="options.length > 0 && showOptions" class="calendar-event has-bg-success" @click="goToDayView('OPTIONS')">
        {{options.length}} Options.
      </a>
      <a v-if="reminders.length > 0 && showReminders" class="calendar-event has-bg-danger" @click="goToDayView('REMINDERS')">
        {{reminders.length}} Rappel.
      </a>
    </div>
  </div>
</template>

<script>
  import { CalendarDayMx } from '../../../mixins'

  export default {
    name: 'SmallCalendarDay',
    mixins: [CalendarDayMx],
    props: {
      displayedEvents: {
        type: Array,
        default: () => []
      },
      selected: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        enabledEvents: {
          RDVS: true,
          OPTIONS: true,
          REMINDERS: true,
          USERS: false
        }
      }
    },
    computed: {
      filteredTotalEvents () {
        return this.allEvents.filter(x => this.enabledEvents[x._type.toUpperCase()]).length
      },
      filteredRdvs () {
        if (this.rdvs) {
          return this.rdvs.filter(x => !x.canceled)
        } else return []
      },
      showRdvs () {
        return this.displayedEvents.includes('RDVS')
      },
      showReminders () {
        return this.displayedEvents.includes('REMINDERS')
      },
      showOptions () {
        return this.displayedEvents.includes('OPTIONS')
      },
      tooltipContent () {
        if (this.totalEvents === 0) {
          return null
        }
        let str = []
        let rdvs = this.rdvs.length
        if (rdvs > 0) {
          str.push(`${rdvs} RDV`)
        }

        let reminders = this.reminders.length
        if (reminders === 1) {
          str.push(`${reminders} Rappel`)
        } else if (reminders > 1) {
          str.push(`${reminders} Rappels`)
        }

        let options = this.options.length
        if (options === 1) {
          str.push(`${options} Option`)
        } else if (options > 1) {
          str.push(`${options} Options`)
        }
        return str.join(', ')
      }
    },
    methods: {
      openDay () {
        this.$emit('open', this.date)
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/home/dashboard-admin/SmallCalendarDay.vue